"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationPicker = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactLocationPicker = _interopRequireDefault(require("react-location-picker"));
var _stringSimilarity = require("string-similarity");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ZOOMED_IN = 10;
var ZOOMED_OUT = 5;
var LocationPicker = /*#__PURE__*/function (_Component) {
  _inherits(LocationPicker, _Component);
  var _super = _createSuper(LocationPicker);
  function LocationPicker(props) {
    var _this;
    _classCallCheck(this, LocationPicker);
    _this = _super.call(this, props);
    _this.state = {
      searchTerm: '',
      updateAdress: false,
      zoom: ZOOMED_OUT,
      defaultPosition: props.defaultLatLng || {
        lat: 48.8589507,
        lng: 2.2770205
      }
    };
    return _this;
  }
  _createClass(LocationPicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var values = this.props.values;
      if (!_lodash.default.isEqual(this.state.defaultPosition.lat, values['address-latitude']) && !_lodash.default.isEqual(this.state.defaultPosition.lng, values['address-longitude'])) {
        this.setState({
          defaultPosition: {
            lat: values['address-latitude'],
            lng: values['address-longitude']
          },
          updateAdress: false
        });
      }
    }
  }, {
    key: "findBestLocationMatch",
    value: function findBestLocationMatch(wordToCompare, states) {
      var bestSimilarity = 0;
      var stateBestMatch = null;
      wordToCompare && states.forEach(function (state) {
        var similarity = (0, _stringSimilarity.compareTwoStrings)(wordToCompare, state.name);
        if (similarity > bestSimilarity) {
          bestSimilarity = similarity;
          stateBestMatch = state;
        }
      });
      return stateBestMatch;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        values = _this$props.values,
        setFieldValue = _this$props.setFieldValue,
        countries = _this$props.countries,
        initialValues = _this$props.initialValues;
      var _this$state = this.state,
        zoom = _this$state.zoom,
        updateAdress = _this$state.updateAdress,
        defaultPosition = _this$state.defaultPosition;
      return /*#__PURE__*/_react.default.createElement(_reactLocationPicker.default, {
        containerElement: /*#__PURE__*/_react.default.createElement("div", {
          style: {
            height: '100%'
          }
        }),
        mapElement: /*#__PURE__*/_react.default.createElement("div", {
          style: {
            height: '400px',
            borderRadius: 4,
            border: '1px solid #b7b7b7'
          }
        }),
        defaultPosition: defaultPosition,
        radius: 100,
        zoom: zoom,
        onChange: function onChange(result) {
          var _result$places$find, _result$places$, _result$places$$addre, _result$places$$addre2;
          var _ref = ((_result$places$find = result.places.find(function (place) {
              return place.types.includes('country');
            })) === null || _result$places$find === void 0 ? void 0 : _result$places$find.address_components[0]) || {},
            _ref$long_name = _ref.long_name,
            countryName = _ref$long_name === void 0 ? '' : _ref$long_name,
            _ref$short_name = _ref.short_name,
            countryCode = _ref$short_name === void 0 ? '' : _ref$short_name;
          var cityName = (_result$places$ = result.places[0]) === null || _result$places$ === void 0 ? void 0 : (_result$places$$addre = _result$places$.address_components) === null || _result$places$$addre === void 0 ? void 0 : (_result$places$$addre2 = _result$places$$addre.find(function (comp) {
            return ['locality', 'administrative_area_level_4', 'administrative_area_level_3', 'administrative_area_level_2', 'administrative_area_level_1'].some(function (type) {
              return comp.types.includes(type);
            });
          })) === null || _result$places$$addre2 === void 0 ? void 0 : _result$places$$addre2.long_name;
          if (updateAdress || !values['address-address_01']) {
            if ('address-country' in initialValues) {
              setFieldValue('address-country', countryName);
            }
            if ('address-country_code' in initialValues) {
              setFieldValue('address-country_code', countryCode);
            }
            if ('address-city' in initialValues) {
              setFieldValue('address-city', cityName || '');
            }
            setFieldValue('address-address_01', result.address);
            setFieldValue('address-latitude', result.position.lat);
            setFieldValue('address-longitude', result.position.lng);
            _this2.setState({
              searchTerm: result.address
            });
          } else {
            _this2.setState({
              updateAdress: true
            });
          }
          var location_country = result.places[result.places.length - 2] && result.places[result.places.length - 2].address_components[result.places[result.places.length - 2].address_components.length - 1].long_name;
          var commune;
          if (result.places.length === 2) {
            commune = location_country;
          } else {
            var returnedResult = result.places[result.places.length - 3] && result.places[result.places.length - 3].address_components[0];
            // Since the google response does not always have the same length, we need to
            // check that the result does not has any of these types to make sure it's a commune
            if (returnedResult) {
              var filterTypes = ['sublocality', 'sublocality_level_1', 'colloquial_area'];
              var notCommune = filterTypes.some(function (item) {
                return returnedResult.types.map(function (type) {
                  return item === type;
                }).some(function (value) {
                  return value;
                });
              });
              if (notCommune) {
                if (result.places.length > 4) {
                  commune = result.places[result.places.length - 4] && result.places[result.places.length - 4].address_components[0].long_name;
                } else {
                  commune = location_country;
                }
              } else {
                commune = returnedResult.long_name;
              }
            }
          }
          var country = _this2.findBestLocationMatch(location_country, countries);
          if (country) {
            setFieldValue('country', country.id);
            _this2.props.dispatch({
              type: 'FETCH_CITIES',
              params: {
                "state.country.id": country.id,
                findCity: _this2.findBestLocationMatch,
                city: commune,
                setField: _this2.props.setFieldValue
              }
            });
          }
        }
      });
    }
  }]);
  return LocationPicker;
}(_react.Component);
exports.LocationPicker = LocationPicker;